import * as http from "http"

import Axios, { AxiosError, AxiosRequestConfig, AxiosResponse, isAxiosError } from "axios"

import { getChatToken } from "./api"

import { REST_CHAT_API_URL } from "@utils/env-management"
import { store } from "@utils/store/store"

export { type AxiosError, isAxiosError }

const responseBody = <T>(response: AxiosResponse<T>) => response

const client = Axios.create({
    baseURL: REST_CHAT_API_URL,
    withCredentials: false,
    httpAgent: new http.Agent({ keepAlive: true }),
})

client.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
        const config = error.config as AxiosRequestConfig & { _retry?: boolean }

        if (error.response?.status === 403 && !config._retry) {
            config._retry = true

            const dispatch = store.dispatch

            const state = store.getState()
            const role = state.chat?.role

            if (role) {
                const newToken = await dispatch(getChatToken(role, false))

                if (newToken) {
                    config.headers = { ...config.headers, Authorization: `Bearer ${newToken}` }
                    return client(config)
                }
            }
        }

        return Promise.reject(error)
    }
)

export const httpClientChat = {
    get: async <T>(url: string, config?: AxiosRequestConfig) =>
        responseBody(await client.get<T>(url, config)),
    post: async <T>(url: string, data?: unknown, config?: AxiosRequestConfig) =>
        responseBody(await client.post<T>(url, data, config)),
}
